function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon",
  d: "M213,5345.5a12.5,12.5,0,1,1,12.5,12.5A12.514,12.514,0,0,1,213,5345.5Zm2,0a10.5,10.5,0,1,0,10.5-10.5A10.512,10.512,0,0,0,215,5345.5Zm2.208,0a8.292,8.292,0,1,1,8.291,8.267A8.288,8.288,0,0,1,217.208,5345.5Zm2,0a6.292,6.292,0,1,0,6.292-6.268A6.287,6.287,0,0,0,219.207,5345.5Zm6.292,1a1,1,0,0,1-1-1v-2.754a1,1,0,0,1,2,0v1.753H228a1,1,0,0,1,0,2Z",
  transform: "translate(-213 -5333)",
  fill: "#3b3d40"
});

var SvgExpierience = function SvgExpierience(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExpierience, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/expierience.63352f77.svg";
export { ForwardRef as ReactComponent };